<template>
  <div class="screen screen__forgot_password screen__background-card">
    <div class="page--container">
      <div class="page--section">
        <el-card class="card card__login">
          <header class="card__header">
            <h1 class="h2 card__title">{{$t('pageTitleExpiredToken')}}</h1>
            <p class="card__paragraph">{{$t('pageDescriptionExpiredToken')}}</p>
          </header>
          <div class="card__footer">
            <div class="card__footer_button_wrap">
              <router-link 
                :to="{ name: 'ForgotPassword' }"
                class="el-button el-button--primary">
                {{$t('authentiationResetPasswordTryAgain')}}
              </router-link>
            </div>
            <p class="card__footer_footnote">
              <router-link class="card__footer_link" :to="{ name: 'Home' }" exact>
                {{$t('applicationCancel')}}
              </router-link>
            </p>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ExpiredToken',
  }
</script>

<style lang="scss" scoped>
  .card__header {
    position: relative;
  }
</style>
